import { Component, OnInit } from "@angular/core";
// import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserMgmtService } from "../user.service";
import { RolesService } from "../../roles/roles.service";
import { CommonService } from "../../../shared/common.service";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-userlist",
  templateUrl: "./userlist.component.html",
  styleUrls: ["./userlist.component.scss"],
})
export class UserlistComponent implements OnInit {
  userDetails;
  auditLogsList: [];
  showCouponList: boolean = false;
  resetPass;
  showaAudit: boolean = false;
  query: string;
  roleList;
  passwordForm: FormGroup;
  statusFormSubmitted: boolean = false;
  hasWriteAccess: boolean = false;
  hasReadAccess: boolean = false;
  editUserForm: FormGroup;

  statusForm: FormGroup;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
    { id: "blocked", name: "Block" },
  ];
  currentUser: any = null;
  selectedUserBookingData: any;
  modaldata;
  stateList = [];
  roles = [];
  // END - Update user variable
  // filters
  searchStartDate: string;
  searchEndDate: string;
  searchUserStatus: string = "";
  searchBy: string = "all";
  searchText1: string;
  searchText2: string;
  searchText3: string;
  // filters end

  userList = [];
  couponList = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 10;
  userSearchType: number = 0;
  minDate: any;
  showUserList: boolean = false;
  maxDate: any;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  searchStatus = "";
  searchUserType = "";
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  mobilePattern = /^[0][1-9][0-9]*$/;

  private modalRef: NgbModalRef;
  searchEndTime: any;
  searchStartTime: string | number | Date;
  description: any;
  offset: number;
  searchfilter: boolean;
  userId: any;
  showCityList: boolean;
  cityList: any;
  citySearch: any;
  route: any;

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private userService: UserMgmtService,
    private roleService: RolesService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit() {
    this.getUserList();
    // const perm = this.commonService.getPermissions("users");
    // this.hasWriteAccess = perm === "W";
    // this.hasReadAccess = perm === "R" || perm === "W";
    // this.getUserList();
    // this.getCityList();
  }

  viewUserDetails(row: any) {
    const id = (row && row._id) || (row && row.userId);
    if (!id) {
      return;
    }
    this.router.navigate(["/main/user-management/user-detail", id]);
  }
  showDescModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    this.description = row;

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.editUserForm.reset();
        this.currentUser = null;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.editUserForm.reset();
        this.currentUser = null;
      }
    );
  }

  openModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    this.description = row.description;
    this.editUserForm.patchValue({
      fullName: row["fullName"],
      email: row["email"],
      address: row["address"],
      mobile: row["mobile"],
      stateId: row["stateId"],
      role: row["role"],
    });
    this.currentUser = { ...row };

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.editUserForm.reset();
        this.currentUser = null;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.editUserForm.reset();
        this.currentUser = null;
      }
    );
  }

  updatePasswordModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.resetPass = row;
    this.statusFormSubmitted = false;

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  resetPasword() {
    this.isLoading = true;
    let request = {
      userId: this.resetPass["userId"],
      newPassword: this.passwordForm.value.password,
    };
    this.userMgmtService.resetPassword(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.passwordForm.reset();
          this.modalRef.close();
          this._snackBar.open("Password reset successfully!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          // Swal.fire("Success", "Password reset successfully!", "success");
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  showDesc(row) {
    Swal.fire({
      text: row.description,

      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
    }).then((result) => {});
    history.pushState(null, "", null);
  }

  // DeleteCoupon(row) {
  //   Swal.fire({
  //     title: "Delete Coupon: " + row.code,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, Delete it!",
  //   }).then((result) => {
  //     if (result.value) {
  //       this.isLoading = true;
  //       this.userMgmtService.deleteCoupon(row.couponId).subscribe(
  //         (res) => {
  //           this.isLoading = false;
  //           if (res["message"] == "Success") {
  //             Swal.fire("Success", "Coupon deleted successfully!", "success");
  //           } else {
  //             Swal.fire("Error", res.data, "error");
  //           }
  //           this.getUserList();
  //         },
  //         (err) => {
  //           this.isLoading = false;
  //         }
  //       );
  //     }
  //   });
  // }

  queryParams() {
    this.offset = this.pageLimit * this.currentPage;
    let query = "";
    query = query + "limit=" + this.pageLimit + "&offset=" + this.offset;
    if (this.searchText1) {
      query = query + "&text=" + this.searchText1.trim();
    }
    if (this.citySearch) {
      query = query + "&cityId=" + this.citySearch.trim();
    }
    if (this.userId) {
      query = query + "&userId=" + this.userId;
    }
    if (this.searchStatus) {
      query = query + "&status=" + this.searchStatus;
    }
    if (this.searchUserType) {
      query = query + "&userType=" + this.searchUserType;
    }

    if (this.searchStartDate && this.searchStartDate != "") {
      // convert to epoch time
      let startDate = new Date(this.searchStartDate);
      query = query + "&startDate=" + Math.floor(startDate.getTime() / 1000);
    }
    if (this.searchEndDate && this.searchEndDate != "") {
      // convert to epoch time
      let endDate = new Date(this.searchEndDate);
      endDate.setDate(endDate.getDate() + 1);
      query = query + "&endDate=" + Math.floor(endDate.getTime() / 1000 - 1);
    }
    query = query + "&expand=bookingData";
    return query;
  }
  total: number = 0;
  pagelimit: number = 5;
  totalPage: number;
  currentPage: number = 0;
  SetPage() {
    this.totalPage = 0;
    this.totalPage = this.total / this.pageLimit;
    this.totalPage = Math.ceil(this.totalPage);
    if (this.totalPage == 1 || this.total <= this.pageLimit) {
      this.totalPage = 1;
    }
  }
  changeEndDate() {
    this.maxDate = this.searchEndDate;
  }
  changeStartDate() {
    this.minDate = this.searchStartDate;
  }
  nextPage() {
    this.currentPage = this.currentPage + 1;
    this.getUserList();
  }
  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.getUserList();
  }
  changePageLimit() {
    this.currentPage = 0;
    this.getUserList();
  }
  // GET USERS (By Default ALL)

  getUserList() {
    let queryParam = "";
    this.showUserList = false;
    var queryValue = this.queryParams();
    var query = "";
    queryValue =
      queryValue + "&sortBy=insertDate" + "&limit=" + this.pagelimit + "&offset=" + this.pagelimit * this.currentPage;
    this.isLoading = true;
    this.userMgmtService.getUserListApi(queryValue).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.userList = res["data"]["userList"];
          this.total = res["data"]["totalCount"];
          this.SetPage();

          if (this.userList.length > 0) {
            this.showUserList = true;
          }
          // console.log(this.driverList)
        } else {
          this.userList = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  activeIndex() {
    localStorage.setItem("activeIndex", "4");
    this.router.navigate(["/main/promo/add"]);
  }

  // getUserList() {
  //   // if (this.userPhone == "" && this.userEmail == "") {
  //   //   this.showUserList = false;
  //   //   return;
  //   // }
  //   // this.showUserList = false;
  //   // this.isLoading = true;

  //   // var queryValue = "userId=" + this.userId;
  //   let query = "";
  //   // this.isLoading = true;
  //   this.userMgmtService.getUserListApi(query).subscribe(
  //     (res) => {
  //       // debugger;

  //       this.isLoading = false;
  //       if (res["message"] == "Success") {
  //         this.userList = res.data.userList;
  //         console.log(this.userList);

  //         // this.userList = res["data"].userList[0];
  //         // this.userId = this.userList.userId;
  //         // if (this.userList.length > 0) {
  //         //   this.userList = true;
  //         // }
  //         // console.log(this.total);
  //         this.SetPage();
  //         this.userList = res["data"];
  //         if (this.userList.length > 0) {
  //           // this.showUserList = true;
  //         }

  //         // console.log(this.userList)
  //       } else {
  //         this.userList = [];
  //       }
  //       this.isLoading = false;
  //     },
  //     (err) => {
  //       this.isLoading = false;
  //     }
  //   );
  // }
  openModalReset(row, content, btn) {
    this.prepareUpdateStatusForm();
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
      centered: true,
    };
    this.userDetails = row;

    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  onReset() {
    this.isLoading = true;
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.isLoading = false;
    }, 2000);
    (this.maxDate = ""),
      (this.minDate = ""),
      (this.searchStatus = ""),
      (this.searchUserType = ""),
      (this.searchText1 = ""),
      (this.citySearch = ""),
      (this.searchText2 = ""),
      (this.searchText3 = ""),
      (this.searchBy = ""),
      (this.searchStartDate = ""),
      (this.searchEndDate = "");
    this.getUserList();
  }

  searchFiltersBtn() {
    this.currentPage = 0;
    this.currentPage = 0;
    // this.searchfilter =  true;
    this.getUserList();
  }

  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      status: ["", [Validators.required]],
    });
  }

  updateUserStatusModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  updateUserStatusForm(test) {
    // debugger;
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.isLoading = true;
      let finalObj = {
        userId: this.userDetails["_id"],
        status: this.statusForm.controls.status.value,
      };
      this.userMgmtService.updateUserStatus(finalObj).subscribe(
        (data) => {
          this.isLoading = false;
          if ((data["message"] = "Success")) {
            this._snackBar.open("User status updated successfully!", "", {
              duration: 5000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            // Swal.fire("Success", "User status updated successfully!", "success");
            this.modalRef.close();
            this.getUserList();
          } else {
            Swal.fire("Error", data.data, "error");
          }
        },
        (err) => {
          this.isLoading = false;
          Swal.fire("Error", err.error.data, "error");
          this.modalRef.close();
          this.getUserList();
        }
      );
    }
  }

  onlyAlphabets(e) {
    return (
      (e.charCode > 64 && e.charCode < 91) ||
      (e.charCode > 96 && e.charCode < 123) ||
      e.charCode == 32 ||
      e.charCode == 45
    );
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0 ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  auditModal(userId, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    // this.auditLogsList = row;
    this.getAuditLogsList(userId);
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.auditLogsList = [];
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getAuditLogsList(userId) {
    this.showaAudit = false;
    this.isLoading = true;
    this.userMgmtService.getAuditLogsListApi(userId).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.auditLogsList = res["data"]["auditLog"];
          if (this.auditLogsList.length > 0) {
            this.showaAudit = true;
          }
          // console.log(this.userList)
        } else {
          this.auditLogsList = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  getCityList() {
    this.showCityList = false;
    this.isLoading = true;
    var queryValue = "type=all";

    this.userService.getCityListApi(queryValue).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.cityList = res["data"]["city"];

          // console.log(this.cityList)
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getFrequency(bookingData: any): string {
    if (!bookingData || !bookingData.howOftens) {
      return "--";
    }
    const howOftens = bookingData.howOftens;
    const keys = Object.keys(howOftens);
    if (keys.length === 0) {
      return "--";
    }
    return keys.map((key) => `${key} (${howOftens[key]})`).join(", ");
  }

  openFrequencyModal(row, content) {
    this.selectedUserBookingData = row.bookingData;
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
      centered: true,
    };

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
}
